import { Icon } from '@iconify/react';
import { IconSettings, IconUsers, IconTool } from '@tabler/icons';
import shoppingBagFill from '@iconify/icons-eva/shopping-bag-fill';
import fileTextFill from '@iconify/icons-eva/file-text-fill';
import lockFill from '@iconify/icons-eva/lock-fill';
import settingsOutline from '@iconify/icons-eva/settings-outline';

const icons = {
  IconSettings,
  IconUsers,
  IconTool
};

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const settingsmgmt = {
  id: 'settings',
  title: 'Settings',
  type: 'group',
  children: [
    {
      id: 'tarrif',
      title: 'Tariff Mgmt',
      type: 'collapse',
      icon: icons.IconSettings,
      children: [
        // {
        //   id: 'updateTariffs',
        //   title: 'Update Tariff Cost',
        //   type: 'item',
        //   url: '/tariff/updateTariffs',
        //   breadcrumbs: false
        // },
        // {
        //   id: 'editTariff',
        //   title: 'Edit Tarrif',
        //   type: 'item',
        //   url: '/underdev',
        //   breadcrumbs: false
        // }
      ]
    },
    {
      id: 'settings',
      title: 'Settings',
      type: 'collapse',
      icon: icons.IconSettings,
      children: [
        {
          id: 'templates',
          title: 'Comm Templates',
          type: 'item',
          url: '/settings/templates',
          breadcrumbs: false
        },
        {
          id: 'paycycles',
          title: 'Cycle Management',
          type: 'item',
          url: '/settings/cyclemgmt',
          breadcrumbs: false
        },
        {
          id: 'limitsmgmt',
          title: 'Limits Management',
          type: 'item',
          url: '/settings/limitsmgmt',
          breadcrumbs: false
        },
        {
          id: 'errorCodes',
          title: 'Error Codes',
          type: 'item',
          url: '/settings/errorcodes',
          breadcrumbs: false
        },
        {
          id: 'claimStatuses',
          title: 'Claim Statuses',
          type: 'item',
          url: '/settings/claimstatuses',
          breadcrumbs: false
        },
        {
          id: 'bankList',
          title: 'Bank List',
          type: 'item',
          url: '/settings/banklist',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'configurations',
      title: 'Configurations',
      type: 'collapse',
      icon: icons.IconTool,
      children: [
        {
          id: 'moduleSettings',
          title: 'User Management',
          type: 'item',
          url: '/settings/configusers',
          breadcrumbs: false
        },
        {
          id: 'enterpriseSettings',
          title: 'Currency Setup',
          type: 'item',
          url: '/',
          breadcrumbs: false
        },
        {
          id: 'userManagement',
          title: 'Module Setup',
          type: 'item',
          url: '/',
          breadcrumbs: false
        },
        {
          id: 'reddcHist',
          title: 'Dependant History',
          type: 'item',
          url: '/clientportfolio/dependantsupload',
          breadcrumbs: false
        },
        {
          id: 'recHist',
          title: 'Receipt History',
          type: 'item',
          url: '/ssb/receipthist',
          breadcrumbs: false
        }
        // {
        //   id: 'login',
        //   title: 'Login',
        //   type: 'item',
        //   url: '/login',
        //   breadcrumbs: false
        // },
        // {
        //   id: 'register',
        //   title: 'Register',
        //   type: 'item',
        //   url: '/register',
        //   breadcrumbs: false
        // }
      ]
    }
  ]
};

export default settingsmgmt;
